import { createSlice } from "@reduxjs/toolkit"

const computerSlice = createSlice({
    name: 'computer',
    initialState: {
        field: [],
        ships: [],
        shipsStats: {
            1: 4,
            2: 3,
            3: 2,
            4: 1
        }
    },
    reducers: {
        createField: (state, action) => {
            state.field = action.payload;
        },
        addShips: (state, action) => {
            state.ships = action.payload;
        },
        shot: (state, action) => {
            state.field[+action.payload].visual = 'shot';
        },
        hit: (state, action) => {
            state.field[+action.payload].visual = 'hit';
        },
        miss: (state, action) => {
            state.field[+action.payload].visual = 'miss';
        },
        mark: (state, action) => {
            state.field[+action.payload].visual = 'mark';
        },
        unmark: (state, action) => {
            state.field[+action.payload].visual = 'blank';
        },
        shotOnMarked: (state, action) => {
            state.field[+action.payload].visual = 'shotOnMarked';
        },
        markKilledShipCell: (state, action) => {
            state.field[+action.payload].killed = true;
        },
        killShip: (state, action) => {
            state.shipsStats[action.payload] = state.shipsStats[action.payload] - 1;
        },
        toInitialValues: state => {
            state.field = [];
            state.ships = [];
            state.shipsStats = {
                1: 4,
                2: 3,
                3: 2,
                4: 1
            };
        },
        continueGame: (state, action) => {
            state.field = action.payload.field;
            state.ships = action.payload.ships;
            state.shipsStats = action.payload.shipsStats;
        }
    }
});

export const { 
    createField,
    addShips,
    shot,
    hit,
    miss,
    mark,
    unmark,
    shotOnMarked,
    markKilledShipCell,
    killShip,
    toInitialValues,
    continueGame
} = computerSlice.actions;

export const computerActions =  computerSlice.actions;

export default computerSlice.reducer;